import type { IconProps } from './types';
import './icons.css';

export default function Loader({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 28}
      height={height || 28}
      viewBox="0 0 28 28"
      className={`icon icon-loader ${className || ''}`}
      fill="none"
    >
      <path
        fill="currentColor"
        d="M14 28c7.732 0 14-6.268 14-14h-2.24c0 6.495-5.265 11.76-11.76 11.76S2.24 20.495 2.24 14 7.505 2.24 14 2.24V0C6.268 0 0 6.268 0 14s6.268 14 14 14Z"
      />
    </svg>
  );
}
